import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { Setting } from '@shared/setting/setting';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingApi extends BaseApi<Setting> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'settings');
  }

  create(): Setting {
    return new Setting();
  }

  getMoneybarSettings(): Observable<Setting[]> {
    return this.httpClient.get<Setting[]>(`${this.endpoint}/moneybar`);
  }

  updateMoneybarSettings(settings: Setting[]): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/moneybar`, settings);
  }
}
